export var Feature;
(function (Feature) {
    Feature["CallSupport"] = "NewClick_CallSupport";
    Feature["BackCallButton"] = "NewClick_BackCallButton";
})(Feature || (Feature = {}));
